import type { WootricConfig } from '../types/wootric';
import type { IntercomConfig } from '../types/intercom';

let cachedWootricConfig: WootricConfig | null = null;
let cachedIntercomConfig: IntercomConfig | null = null;

const defaultWootricConfig: WootricConfig = {
  wootricDomain: '',
  productionAccountId: '',
  testAccountId: '',
  product: '',
  productReportingCode: '',
  linkUrl: '',
  linkWord: '',
  blacklistedDomains: [],
};

export const configService = {
  async getWootricConfig(): Promise<WootricConfig> {
    if (cachedWootricConfig) {
      return cachedWootricConfig;
    }

    try {
      const response = await fetch('/config/wootric.config.json');
      if (!response.ok) {
          console.warn('Wootric config not found, using defaults');
          return defaultWootricConfig;
      }

      cachedWootricConfig = await response.json();
      return cachedWootricConfig!;
    } catch (error) {
      console.error('Failed to load Wootric config:', error);
      return defaultWootricConfig;
    }
  },

  async getIntercomConfig(): Promise<IntercomConfig> {
    if (cachedIntercomConfig) {
      return cachedIntercomConfig;
    }

    const defaultIntercomConfig: IntercomConfig = { appId: '' };

    try {
      const response = await fetch('/config/intercom.config.json');
      if (!response.ok) {
        console.warn('Intercom config not found, using defaults');
        return defaultIntercomConfig;
      }

      cachedIntercomConfig = await response.json();
      return cachedIntercomConfig!;
    } catch (error) {
      console.error('Failed to load Intercom config:', error);
      return defaultIntercomConfig;
    }
  },

  clearCache(): void {
    cachedWootricConfig = null;
    cachedIntercomConfig = null;
  },
};
